// import React, { useState, useEffect, useMemo } from "react"
// import { Container, Form, Row, Table } from "reactstrap"
// import { useNavigate } from "react-router-dom"
// import Breadcrumbs from "../../../components/Common/Breadcrumb"
// import Select from "react-select"
// import Swal from "sweetalert2"
// import {
//   serviceOption,
//   workOptionService,
// } from "utils/common-options"
// import { Switch } from "antd"
// import axios from "axios"
// import configure from "configure"
// import Loader from "pages/Separate/Loader"
// import { fetchNodeData } from "utils/common-fetchData"
// import { useSelector } from "react-redux"
// import AsyncSelect from "react-select/async";
// import { debounce } from "lodash";

// const loadLeadOptions = debounce((inputValue, callback, options) => {
//   const filtered = options
//     .filter(o => o.label?.toLowerCase().includes(inputValue.toLowerCase()))
//     .slice(0, 50)
//   callback(filtered)
// }, 400)

// const Addportfolio = () => {
//   const navigate = useNavigate()
//   const generalLocation = useSelector(state => state?.location?.locations)
//   const [PortfolioName, setPortfolioName] = useState("")
//   const [Lead, setLead] = useState("")
//   const [SelectedCaseStudies, setSelectedCaseStudies] = useState([])
//   const [companyName, setCompanyName] = useState("")
//   const [leadEmail, setLeadEmail] = useState("")
//   const [leadContact, setLeadContact] = useState("")
//   const [website, setWebsite] = useState("")
//   const [Ptype, setPtype] = useState(false)
//   const [techOptions, setTechOption] = useState([])
//   const [mainService, setMainService] = useState([])
//   const [Leads, setLeads] = useState([])
//   const [CaseStudies, setCaseStudies] = useState([])
//   const [FilteredCaseStudies, setFilteredCaseStudies] = useState([])

//   const [isLoading, setLoading] = useState(false)

//   useEffect(() => {
//     fetchData()
//     onGetTechnologies()
//   }, [])

//   async function fetchData() {
//     setLoading(true)
//     axios
//       .get(`${configure.nodeApi}/case-study`)
//       .then(res => {
//         setLoading(false)
//         const formattedOptions = res?.data?.caseStudy?.map(item => ({
//           ...item, // keep all original properties
//           label: item.project_name,
//           value: item.id,
//         }))

//         setCaseStudies(formattedOptions)
//         setFilteredCaseStudies(formattedOptions) // show all by default
//       })
//       .catch(e => {
//         setLoading(false)
//         console.log(e)
//       })
//   }
//   const toggleLoading = (loading) => {
//     setLoading(loading);
//   }
//   const onGetTechnologies = async () => {
//     const res = await fetchNodeData(toggleLoading, 'portfolio-technologies');
//     if (res?.success) {
//       setTechOption(res?.data?.map((obj) => ({
//         value: obj?.id,
//         label: obj?.name
//       })))
//     }
//   }

//   async function fetchLData() {
//     setLoading(true)
//     axios
//       .get(`${configure.nodeApi}/getAllLeads/${localStorage.getItem("auth_id")}`)
//       .then(res => {
//         setLoading(false)
//         const formattedLeads = res?.data?.leads?.map(item => ({
//           ...item, // retain all original lead properties
//           label: item.company,
//           value: item.id,
//         }))

//         setLeads(formattedLeads)
//       })
//       .catch(e => {
//         setLoading(false)
//         console.log(e)
//       })
//   }

//   const [filters, setFilters] = useState({
//     location: "",
//     service: "",
//     technology: "",
//   })

//   const [error, setError] = useState({})

//   const handleFilterChange = (field, value) => {
//     setFilters(prev => ({ ...prev, [field]: value }))
//   }

//   const savePortfolio = async e => {
//     e.preventDefault()

//     const errors = {}
//     if (!PortfolioName) errors.PortfolioName = "Portfolio name is required"
//     if (!SelectedCaseStudies.length)
//       errors.CaseStudies = "Select at least one case study"

//     setError(errors)
//     if (Object.keys(errors).length > 0) return

//     const payload = {
//       portfolio_name: PortfolioName,
//       is_lead_type: Ptype, // boolean (true/false) or 1/0
//       lead_id: Lead.value,
//       lead_company_name: companyName || "",
//       lead_email: leadEmail || "",
//       lead_contact: leadContact || "",
//       lead_website: website || "",
//       caseStudyIds: SelectedCaseStudies.map(cs => cs.value)?.join(","),
//       added_by: localStorage.getItem('auth_id')
//     }

//     try {
//       setLoading(true)

//       const response = await axios.post(
//         `${configure.nodeApi}/portfolio`,
//         payload,
//         {
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//           },
//         }
//       )

//       setLoading(false)

//       Swal.fire({
//         icon: "success",
//         title: "Success",
//         text: "Portfolio saved successfully!",
//       })

//       setTimeout(() => {
//         navigate(`${configure.appUrl}portfolio`)
//       }, 1000)
//     } catch (error) {
//       setLoading(false)
//       console.error("Error saving portfolio:", error)

//       swal({
//         icon: "error",
//         title: "Error",
//         text: "Failed to save portfolio. Please try again.",
//       })
//     }
//   }

//   const groupedByService = useMemo(() => {
//     const grouped = {}
//     SelectedCaseStudies.forEach(study => {
//       const service = study.services || "Unknown"
//       if (!grouped[service]) grouped[service] = []
//       grouped[service].push(study)
//     })
//     return grouped
//   }, [SelectedCaseStudies])

//   const handleApplyFilter = e => {
//     e.preventDefault()
//     console.log(CaseStudies, filters)
//     const filtered = CaseStudies.filter(item => {
//       const matchesLocation =
//         !filters.location || item.location == filters.location.value

//       const matchesService =
//         !filters.service || item.services == filters.service.value

//       const matchesTechnology =
//         !filters.technology ||
//         (Array.isArray(item.technology) &&
//           item.technology.includes(filters.technology.value))

//       return matchesLocation && matchesService && matchesTechnology
//     })

//     setFilteredCaseStudies(filtered)
//   }


//   return (
//     <div className="page-content mb-3">
//       {isLoading && <Loader />}
//       <Container fluid>
//         <Breadcrumbs title="Dashboard" breadcrumbItem="Add Portfolio" />
//         <Row className="px-1">
//           <Form onSubmit={savePortfolio}>
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <div className="col-md-6 mb-3">
//                 <h5 className="mb-3">Portfolio Information</h5>
//               </div>
//               <div className="col-md-6 mb-3 text-end">
//                 <button type="submit" className="btn btn-save btn-label">
//                   <i className="fas fa-save me-1 label-icon" /> Save
//                 </button>
//                 <button
//                   type="button"
//                   onClick={() => navigate(-1)}
//                   className="btn btn-red btn-label ms-2"
//                 >
//                   <i className="dripicons-cross me-2 label-icon" /> Cancel
//                 </button>
//               </div>
//               <div className="col-md-12 mb-3">
//                 <div className="row">
//                   <div className="col-md-2">
//                     <label>Filter by Location</label>
//                     <Select
//                       className="basic-multi-select"
//                       classNamePrefix="border-radius select"
//                       placeholder="Location"
//                       onChange={e => handleFilterChange("location", e)}
//                       options={generalLocation}
//                     ></Select>
//                   </div>
//                   <div className="col-md-2">
//                     <label>Filter by Service</label>
//                     <Select
//                       className="basic-multi-select"
//                       classNamePrefix="border-radius select"
//                       placeholder="Service"
//                       options={workOptionService}
//                       onChange={(e) => setMainService(e)}
//                     ></Select>
//                   </div>
//                   <div className="col-md-3">
//                     <label>Filter by Sub Service</label>
//                     <Select
//                       className="basic-multi-select"
//                       classNamePrefix="border-radius select"
//                       placeholder="Service"
//                       onChange={e => handleFilterChange("service", e)}
//                       options={serviceOption?.filter((obj) => obj?.sub == mainService?.value)}
//                     ></Select>
//                   </div>
//                   <div className="col-md-4">
//                     <label>Filter by Technology</label>
//                     <Select
//                       className="basic-multi-select"
//                       classNamePrefix="border-radius select"
//                       placeholder="Technology"
//                       onChange={e => handleFilterChange("technology", e)}
//                       options={techOptions}
//                     ></Select>
//                   </div>
//                   <div className="col-md-1 mt-4">
//                     <button
//                       onClick={e => handleApplyFilter(e)}
//                       className="btn btn-outline-secondary  me-3"
//                     >
//                       <i className="fas fa-filter"></i>
//                     </button>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-md-12 mb-3">
//                 <label>
//                   Select Case Studies <span className="text-danger">*</span>
//                 </label>
//                 <Select
//                   isMulti
//                   className="basic-multi-select"
//                   placeholder="Select Case Studies"
//                   classNamePrefix="border-radius select"
//                   value={SelectedCaseStudies}
//                   onChange={selectedOption =>
//                     setSelectedCaseStudies(selectedOption)
//                   }
//                   loading={isLoading}
//                   options={FilteredCaseStudies}
//                 ></Select>
//                 {error.CaseStudies && (
//                   <span className="text-danger">{error.CaseStudies}</span>
//                 )}
//               </div>
//               {/* Portfolio Name */}
//               <div className="col-md-4 mb-3">
//                 <label>
//                   Portfolio Name <span className="text-danger">*</span>
//                 </label>
//                 <input
//                   className="form-control"
//                   placeholder="Enter Portfolio Name"
//                   value={PortfolioName}
//                   onChange={e => setPortfolioName(e.target.value)}
//                 />
//                 {error.PortfolioName && (
//                   <span className="text-danger">{error.PortfolioName}</span>
//                 )}
//               </div>
//               <div className="col-md-2 mb-3">
//                 <label>
//                   Portfolio Type <span className="text-danger">*</span>
//                 </label>
//                 <div>
//                   <Switch
//                     checked={Ptype}
//                     className="mt-1"
//                     checkedChildren="Lead"
//                     unCheckedChildren="General"
//                     style={{ fontSize: "14px" }}
//                     onChange={e => {
//                       setPtype(e), fetchLData()
//                     }}
//                   />
//                 </div>
//               </div>
//               {/* Lead Selection */}
//               {Ptype && (
//                 <div className="col-md-4 mb-3">
//                   <label>
//                     Lead <span className="text-danger">*</span>
//                   </label>

//                   <AsyncSelect
//                     className="basic-multi-select"
//                     classNamePrefix="border-radius select"
//                     placeholder="Search Lead..."
//                     cacheOptions
//                     defaultOptions={Leads.slice(0, 50)}
//                     value={Lead}
//                     loadOptions={(inputValue, callback) =>
//                       loadLeadOptions(inputValue, callback, Leads)
//                     }
//                     onChange={selectedOption => {
//                       setLead(selectedOption)
//                       setCompanyName(selectedOption?.company)
//                       setLeadEmail(selectedOption?.email)
//                       setLeadContact(selectedOption?.phonenumber)
//                       setWebsite(selectedOption?.website)
//                     }}
//                     noOptionsMessage={({ inputValue }) =>
//                       inputValue ? "No leads found" : "Type to search"
//                     }
//                     loadingMessage={() => "Searching..."}
//                   />

//                   {/* <Select
//                     className="basic-multi-select"
//                     classNamePrefix="border-radius select"
//                     placeholder="Select Lead"
//                     value={Lead}
//                     onChange={selectedOption => {
//                       setLead(selectedOption),
//                         setCompanyName(selectedOption?.company)
//                       setLeadEmail(selectedOption?.email)
//                       setLeadContact(selectedOption?.contact)
//                       setWebsite(selectedOption?.website)
//                       setLeadContact(selectedOption?.phonenumber)
//                     }}
//                     options={Leads}
//                   ></Select> */}
//                   {error.Lead && (
//                     <span className="text-danger">{error.Lead}</span>
//                   )}
//                 </div>
//               )}
//             </Row>
//             {Ptype && (
//               <Row className="bg-white px-2 py-4 shadow mt-3">
//                 <div className="col-12 mb-3">
//                   <h5 className="mb-3">Lead & Company Information</h5>
//                 </div>

//                 {/* Company Name */}
//                 <div className="col-md-4 mb-3">
//                   <label>Company Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Enter Company Name"
//                     value={companyName}
//                     onChange={e => setCompanyName(e.target.value)}
//                   />
//                 </div>

//                 {/* Lead Email */}
//                 <div className="col-md-4 mb-3">
//                   <label>Lead Email</label>
//                   <input
//                     type="email"
//                     className="form-control"
//                     placeholder="Enter Email"
//                     value={leadEmail}
//                     onChange={e => setLeadEmail(e.target.value)}
//                   />
//                 </div>

//                 {/* Lead Contact */}
//                 <div className="col-md-4 mb-3">
//                   <label>Lead Contact</label>
//                   <input
//                     type="tel"
//                     className="form-control"
//                     placeholder="Enter Contact"
//                     value={leadContact}
//                     onChange={e => setLeadContact(e.target.value)}
//                   />
//                 </div>
//               </Row>
//             )}
//           </Form>
//         </Row>
//         {SelectedCaseStudies.length > 0 && (
//           <Row className=" px-2 py-4 shadow bg-white mt-3">
//             <div className="col-12 mb-3">
//               <h5>Selected Case Studies</h5>
//             </div>

//             {Object.entries(groupedByService).map(([service, studies]) => {
//               return (
//                 <div key={service} className="col-12 mb-4 bg-light p-4">
//                   <h5 className="text-dark mb-3">{service}</h5>
//                   <div className="row">
//                     {studies.map(cs => {
//                       let projectImages = []
//                       try {
//                         if (cs.project_image) {
//                           projectImages = JSON.parse(cs.project_image).map(
//                             img => img.replace(/\\/g, "/")
//                           )
//                         }
//                       } catch (err) {
//                         console.error("Error parsing project_image:", err)
//                       }
//                       return (
//                         <div key={cs.value} className="col-md-3 mb-3 cursor-pointer" onClick={() => navigate(
//                           `${configure.appUrl}view-case-study/${cs?.id}`
//                         )}>
//                           <div className="card  shadow-sm">
//                             <img
//                               src={
//                                 projectImages
//                                   ? `${configure.nodeImgApi}/${projectImages[0]}`
//                                   : ''
//                               }
//                               className="object-fit-cover card-img-top"
//                               alt={cs.label}
//                               style={{ height: "250px", objectFit: "cover" }}
//                             />
//                             <div className="card-body">
//                               <h6 className="card-title text-left text-purple">
//                                 {cs.label}
//                               </h6>
//                               <div className="d-flex justify-content-between">
//                                 <div className="fw-bolder text-dark ">
//                                   <h6 className="fst-italic fw-medium">{cs?.technologies?.map((obj, i, arr) => (
//                                     <span className="" key={i}>
//                                       {obj}{i < arr.length - 1 ? ', ' : ''}
//                                     </span>
//                                   ))}</h6>
//                                 </div>
//                               </div>
//                               <h6 className="lh-base case-desc" dangerouslySetInnerHTML={{ __html: cs.project_overview?.slice(0, 100) }} />

//                             </div>
//                           </div>
//                         </div>
//                       )
//                     })}
//                   </div>
//                 </div>
//               )
//             })}
//           </Row>
//         )}
//       </Container>
//     </div>
//   )
// }

// export default Addportfolio





















import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Container, Form, Modal, Row } from "reactstrap"
import { useNavigate } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Select from "react-select"
import Swal from "sweetalert2"
import { serviceOption, workOptionService } from "utils/common-options"
import { Switch } from "antd"
import axios from "axios"
import configure from "configure"
import Loader from "pages/Separate/Loader"
import { fetchNodeData } from "utils/common-fetchData"
import { useSelector } from "react-redux"
import AsyncSelect from "react-select/async"
import { debounce } from "lodash"
import ViewCaseStudy from "../CaseStudy/ViewCaseStudy"

const loadLeadOptions = debounce((inputValue, callback, options) => {
  const filtered = options
    .filter(o => o.label?.toLowerCase().includes(inputValue.toLowerCase()))
    .slice(0, 50)
  callback(filtered)
}, 400)

const Addportfolio = () => {
  const navigate = useNavigate()
  let generalLocation = useSelector(state => state?.location?.locations)

  generalLocation = generalLocation?.filter(item => item.value !== 2)

  const [PortfolioName, setPortfolioName] = useState("")
  const [Lead, setLead] = useState(null)
  const [SelectedCaseStudies, setSelectedCaseStudies] = useState([])
  const [companyName, setCompanyName] = useState("")
  const [leadEmail, setLeadEmail] = useState("")
  const [leadContact, setLeadContact] = useState("")
  const [website, setWebsite] = useState("")
  const [Ptype, setPtype] = useState(false)
  const [techOptions, setTechOption] = useState([])
  const [mainService, setMainService] = useState(null)
  const [Leads, setLeads] = useState([])
  const [CaseStudies, setCaseStudies] = useState([])
  const [searchText, setSearchText] = useState("")
  const [isLoading, setLoading] = useState(false)
  const [modal_fullscreen, setmodal_fullscreen] = useState(false)
  const [projectId, setProjectId] = useState(null)
  const [error, setError] = useState({})

  // ── multi filters ─────────────────────────────────────────────────────────
  const [filters, setFilters] = useState({
    locations: [],
    service: null,
    technologies: [],
  })

  // ── load on mount ─────────────────────────────────────────────────────────
  useEffect(() => {
    fetchData()
    onGetTechnologies()
  }, [])

  async function fetchData() {
    setLoading(true)
    try {
      const res = await axios.get(`${configure.nodeApi}/case-study`)
      const formatted = res?.data?.caseStudy?.map(item => ({
        ...item,
        label: item.project_name,
        value: item.id,
      }))
      setCaseStudies(formatted || [])
    } catch (e) { console.log(e) }
    finally { setLoading(false) }
  }

  const onGetTechnologies = async () => {
    const res = await fetchNodeData(setLoading, "portfolio-technologies")
    if (res?.success) {
      setTechOption(res?.data?.map(obj => ({ value: obj?.id, label: obj?.name })))
    }
  }

  async function fetchLData() {
    setLoading(true)
    try {
      const res = await axios.get(`${configure.nodeApi}/getAllLeads/${localStorage.getItem("auth_id")}`)
      const formatted = res?.data?.leads?.map(item => ({
        ...item, label: `${item.id} - ${item.company || "unknown"}`, value: item.id,
      }))
      setLeads(formatted || [])
    } catch (e) { console.log(e) }
    finally { setLoading(false) }
  }

  // ── filtered list (reactive — no apply button needed) ─────────────────────
  const filteredCaseStudies = useMemo(() => {
    return CaseStudies.filter(item => {
      const matchLoc = !filters.locations.length ||
        filters.locations.some(l => l.value == item.location)

      const matchSvc = !filters.service ||
        item.services == filters.service.value

      const matchTech = !filters.technologies.length ||
        filters.technologies.some(t =>
          Array.isArray(item.technology) && item.technology.includes(t.value)
        )

      const matchSearch = !searchText ||
        item.label?.toLowerCase().includes(searchText.toLowerCase())

      return matchLoc && matchSvc && matchTech && matchSearch
    })
  }, [CaseStudies, filters, searchText])

  // ── toggle single case study ──────────────────────────────────────────────
  const toggleCaseStudy = useCallback(cs => {
    setSelectedCaseStudies(prev => {
      const exists = prev.find(s => s.value === cs.value)
      return exists ? prev.filter(s => s.value !== cs.value) : [...prev, cs]
    })
  }, [])

  const isSelected = cs => SelectedCaseStudies.some(s => s.value === cs.value)

  const selectAll = () => {
    const toAdd = filteredCaseStudies.filter(cs => !isSelected(cs))
    setSelectedCaseStudies(prev => [...prev, ...toAdd])
  }

  // ── save ──────────────────────────────────────────────────────────────────
  const savePortfolio = async e => {
    e.preventDefault()

    const errors = {}
    if (!PortfolioName) errors.PortfolioName = "Portfolio name is required"
    if (!SelectedCaseStudies.length) errors.CaseStudies = "Select at least one case study"
    setError(errors)
    if (Object.keys(errors).length > 0) return

    const payload = {
      portfolio_name: PortfolioName,
      is_lead_type: Ptype,
      lead_id: Lead?.value || null,
      lead_company_name: companyName || "",
      lead_email: leadEmail || "",
      lead_contact: leadContact || "",
      lead_website: website || "",
      caseStudyIds: SelectedCaseStudies.map(cs => cs.value).join(","),
      added_by: localStorage.getItem("auth_id"),
    }

    try {
      setLoading(true)
      await axios.post(`${configure.nodeApi}/portfolio`, payload, {
        headers: { Accept: "application/json", "Content-Type": "application/json" },
      })
      setLoading(false)
      Swal.fire({ icon: "success", title: "Success", text: "Portfolio saved successfully!" })
      setTimeout(() => navigate(`${configure.appUrl}portfolio`), 1000)
    } catch (error) {
      setLoading(false)
      Swal.fire({ icon: "error", title: "Error", text: "Failed to save portfolio. Please try again." })
    }
  }

  return (
    <div className="page-content mb-3">
      {isLoading && <Loader />}
      <Container fluid >
        <Breadcrumbs title="Dashboard" breadcrumbItem="Add Portfolio" />

        <Form onSubmit={savePortfolio}>
          {/* ── Top status bar ──────────────────────────────────────────── */}
          <div
            className="d-flex align-items-center justify-content-between p-3 mb-3 rounded"
            style={{ background: "#fff", border: "1px solid #e9e9ef", boxShadow: "0 1px 6px rgba(0,0,0,0.05)" }}
          >
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <span style={{ fontSize: 13 }}>
                <span
                  className="rounded-pill px-2 py-1 me-1"
                  style={{ background: "#f3e8ff", color: "#7c3aed", fontSize: 11, fontWeight: 600 }}
                >
                  {SelectedCaseStudies.length}
                </span>
                <span className="text-muted">Case Studies Selected</span>
              </span>
              <span className="text-muted" style={{ fontSize: 13 }}>•</span>
              <span style={{ fontSize: 13 }}>
                <span className="text-muted">Type: </span>
                <strong>{Ptype ? "Lead" : "General"}</strong>
              </span>
            </div>
            <div className="d-flex gap-2">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="btn btn-red btn-label ms-2"
              >
                <i className="dripicons-cross me-2 label-icon" /> Cancel
              </button>
              <button type="submit" className="btn btn-purple btn-label">
                <i className="fas fa-save me-2 label-icon" /> Save Portfolio
              </button>
            </div>
          </div>

          {/* ── Portfolio Details ────────────────────────────────────────── */}
          <div
            className="px-3 py-4 mb-3 rounded"
            style={{ background: "#fff", border: "1px solid #e9e9ef", boxShadow: "0 1px 6px rgba(0,0,0,0.05)" }}
          >
            <p className="text-muted mb-3" style={{ fontSize: 11, fontWeight: 600, letterSpacing: "0.8px", textTransform: "uppercase" }}>
              <i className="fas fa-info-circle me-1" /> Portfolio Details
            </p>
            <div className="row g-3 align-items-start">
              <div className="col-md-5">
                <label className="form-label mb-1" style={{ fontSize: 12 }}>
                  Portfolio Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  placeholder="Enter Portfolio Name"
                  value={PortfolioName}
                  onChange={e => setPortfolioName(e.target.value)}
                />
                {error.PortfolioName && (
                  <span className="text-danger" style={{ fontSize: 12 }}>{error.PortfolioName}</span>
                )}
              </div>

              <div className="col-md-3">
                <label className="form-label mb-1" style={{ fontSize: 12 }}>
                  Portfolio Type <span className="text-danger">*</span>
                </label>
                <div className="d-flex align-items-center gap-2 mt-1">
                  <Switch
                    checked={Ptype}
                    checkedChildren="Lead"
                    unCheckedChildren="General"
                    style={{ fontSize: "14px" }}
                    onChange={e => {
                      setPtype(e)
                      if (e) fetchLData()
                      else { setLead(null); setCompanyName(""); setLeadEmail(""); setLeadContact(""); setWebsite("") }
                    }}
                  />
                  <span className="text-muted" style={{ fontSize: 12 }}>
                    Toggle for Featured portfolio
                  </span>
                </div>
              </div>

              {Ptype && (
                <div className="col-md-4">
                  <label className="form-label mb-1" style={{ fontSize: 12 }}>
                    Lead <span className="text-danger">*</span>
                  </label>
                  <AsyncSelect
                    className="basic-multi-select"
                    classNamePrefix="border-radius select"
                    placeholder="Search Lead..."
                    cacheOptions
                    defaultOptions={Leads.slice(0, 50)}
                    value={Lead}
                    loadOptions={(inputValue, callback) =>
                      loadLeadOptions(inputValue, callback, Leads)
                    }
                    onChange={selectedOption => {
                      setLead(selectedOption)
                      setCompanyName(selectedOption?.company)
                      setLeadEmail(selectedOption?.email)
                      setLeadContact(selectedOption?.phonenumber)
                      setWebsite(selectedOption?.website)
                    }}
                    noOptionsMessage={({ inputValue }) =>
                      inputValue ? "No leads found" : "Type to search"
                    }
                    loadingMessage={() => "Searching..."}
                  />
                  {error.Lead && (
                    <span className="text-danger" style={{ fontSize: 12 }}>{error.Lead}</span>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* ── Lead & Company Info ───────────────────────────────────────── */}
          {Ptype && (
            <div
              className="px-3 py-4 mb-3 rounded"
              style={{ background: "#fff", border: "1px solid #e9e9ef", boxShadow: "0 1px 6px rgba(0,0,0,0.05)" }}
            >
              <p className="text-muted mb-3" style={{ fontSize: 11, fontWeight: 600, letterSpacing: "0.8px", textTransform: "uppercase" }}>
                <i className="fas fa-building me-1" /> Lead & Company Information
              </p>
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label mb-1" style={{ fontSize: 12 }}>Company Name</label>
                  <input type="text" className="form-control" placeholder="Enter Company Name" value={companyName}
                    disabled
                  // onChange={e => setCompanyName(e.target.value)}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1" style={{ fontSize: 12 }}>Lead Email</label>
                  <input type="email" className="form-control" placeholder="Enter Email" value={leadEmail}
                    disabled
                  // onChange={e => setLeadEmail(e.target.value)} 
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1" style={{ fontSize: 12 }}>Lead Contact</label>
                  <input type="tel" className="form-control" placeholder="Enter Contact"
                    value={leadContact}
                    disabled
                  //  onChange={e => setLeadContact(e.target.value)} 
                  />
                </div>
              </div>
            </div>
          )}

          {/* ── Filter row ───────────────────────────────────────────────── */}
          <div
            className="px-3 py-4 mb-3 rounded"
            style={{ background: "#fff", border: "1px solid #e9e9ef", boxShadow: "0 1px 6px rgba(0,0,0,0.05)" }}
          >
            <p className="text-muted mb-2" style={{ fontSize: 11, fontWeight: 600, letterSpacing: "0.8px", textTransform: "uppercase" }}>
              <i className="fas fa-filter me-1" /> Filter Projects
            </p>
            <div className="row g-2 align-items-end">
              <div className="col-md-3">
                <label className="form-label mb-1" style={{ fontSize: 12 }}>Location</label>
                <Select
                  isMulti
                  className="basic-multi-select"
                  classNamePrefix="border-radius select"
                  placeholder="All Locations"
                  options={generalLocation}
                  value={filters.locations}
                  onChange={v => setFilters(f => ({ ...f, locations: v || [] }))}
                />
              </div>
              <div className="col-md-2">
                <label className="form-label mb-1" style={{ fontSize: 12 }}>Service</label>
                <Select
                  className="basic-multi-select"
                  classNamePrefix="border-radius select"
                  placeholder="Service"
                  isClearable
                  options={workOptionService}
                  value={mainService}
                  onChange={v => {
                    setMainService(v)
                    setFilters(f => ({ ...f, service: null })) // reset sub service
                  }}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label mb-1" style={{ fontSize: 12 }}>Sub Service</label>
                <Select
                  className="basic-multi-select"
                  classNamePrefix="border-radius select"
                  placeholder="All Sub Services"
                  isClearable
                  options={serviceOption?.filter(obj => obj?.sub == mainService?.value)}
                  value={filters.service}
                  onChange={v => setFilters(f => ({ ...f, service: v }))}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label mb-1" style={{ fontSize: 12 }}>Technology</label>
                <Select
                  isMulti
                  className="basic-multi-select"
                  classNamePrefix="border-radius select"
                  placeholder="All Technologies"
                  options={techOptions}
                  value={filters.technologies}
                  onChange={v => setFilters(f => ({ ...f, technologies: v || [] }))}
                />
              </div>
            </div>
          </div>

          {/* ── Split panel ──────────────────────────────────────────────── */}
          <div className="row g-3 mb-3">
            {/* LEFT — Available Projects */}
            <div className="col-md-6">
              <div
                className="h-100 rounded"
                style={{ background: "#fff", border: "1px solid #e9e9ef", boxShadow: "0 1px 6px rgba(0,0,0,0.05)" }}
              >
                {/* Panel header */}
                <div
                  className="d-flex align-items-center justify-content-between p-3"
                  style={{ borderBottom: "1px solid #f0f0f0" }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <p className="mb-0 text-muted" style={{ fontSize: 11, fontWeight: 600, letterSpacing: "0.8px", textTransform: "uppercase" }}>
                      Available Projects
                    </p>
                    <span
                      className="rounded-pill px-2"
                      style={{ background: "#f3f4f6", color: "#6b7280", fontSize: 11, fontWeight: 600 }}
                    >
                      {filteredCaseStudies.length} projects
                    </span>
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary py-0"
                    style={{ fontSize: 12 }}
                    onClick={selectAll}
                  >
                    Select All
                  </button>
                </div>

                {/* Search */}
                <div className="p-3" style={{ borderBottom: "1px solid #f0f0f0" }}>
                  <div className="position-relative">
                    <i
                      className="bx bx-search-alt"
                      style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#adb5bd", fontSize: 16 }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      style={{ paddingLeft: 32, borderRadius: 6 }}
                      placeholder="Search within filtered results..."
                      value={searchText}
                      onChange={e => setSearchText(e.target.value)}
                    />
                  </div>
                </div>

                {/* List */}
                <div
                  className="pb-3"
                  style={{ maxHeight: 420, overflowY: "auto" }}>
                  {filteredCaseStudies.length === 0 ? (
                    <div className="text-center text-muted py-5" style={{ fontSize: 13 }}>
                      No projects match the current filters.
                    </div>
                  ) : (
                    filteredCaseStudies.map(cs => {
                      const selected = isSelected(cs)
                      return (
                        <div
                          key={cs.value}
                          onClick={() => toggleCaseStudy(cs)}
                          className="d-flex align-items-center justify-content-between px-3 py-2"
                          style={{
                            cursor: "pointer",
                            borderBottom: "1px solid #f8f8f8",
                            background: selected ? "#faf5ff" : "transparent",
                            transition: "background 0.15s",
                          }}
                          onMouseEnter={e => { if (!selected) e.currentTarget.style.background = "#fdfbff" }}
                          onMouseLeave={e => { if (!selected) e.currentTarget.style.background = "transparent" }}
                        >
                          <div className="d-flex align-items-center gap-2">
                            {/* Checkbox */}
                            <div
                              style={{
                                width: 18, height: 18, borderRadius: 4, flexShrink: 0,
                                border: `2px solid ${selected ? "#7c3aed" : "#d1d5db"}`,
                                background: selected ? "#7c3aed" : "#fff",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                transition: "all 0.15s",
                              }}
                            >
                              {selected && <i className="fas fa-check" style={{ color: "#fff", fontSize: 9 }} />}
                            </div>

                            <div>
                              <p className="mb-0 fw-semibold" style={{ fontSize: 13, color: selected ? "#5b21b6" : "#1f2937" }}>
                                {cs.label}
                              </p>
                              <div className="d-flex gap-1 mt-1 flex-wrap">
                                {cs.location && (
                                  <span style={{ fontSize: 10, background: "#fef3c7", color: "#92400e", borderRadius: 4, padding: "1px 6px" }}>
                                    {generalLocation?.find(l => l.value == cs.location)?.label || null}
                                  </span>
                                )}
                                {cs.services && (
                                  <span style={{ fontSize: 10, background: "#e0f2fe", color: "#0369a1", borderRadius: 4, padding: "1px 6px" }}>
                                    {cs.services}
                                  </span>
                                )}
                                {Array.isArray(cs.technologies) && cs.technologies.slice(0, 2).map((t, i) => (
                                  <span key={i} style={{ fontSize: 10, background: "#f0fdf4", color: "#166534", borderRadius: 4, padding: "1px 6px" }}>
                                    {t}
                                  </span>
                                ))}
                              </div>
                            </div>
                          </div>

                          <div
                            style={{
                              width: 24, height: 24, borderRadius: 6, flexShrink: 0,
                              border: `1px solid ${selected ? "#7c3aed" : "#d1d5db"}`,
                              display: "flex", alignItems: "center", justifyContent: "center",
                              color: selected ? "#7c3aed" : "#9ca3af", fontSize: 12,
                            }}
                          >
                            <i className={`fas fa-${selected ? "check" : "plus"}`} />
                          </div>
                        </div>
                      )
                    })
                  )}
                </div>

                {error.CaseStudies && (
                  <div className="px-3 py-2">
                    <span className="text-danger" style={{ fontSize: 12 }}>{error.CaseStudies}</span>
                  </div>
                )}
              </div>
            </div>

            {/* RIGHT — Selected Case Studies */}
            <div className="col-md-6">
              <div
                className="h-100 rounded"
                style={{ background: "#fff", border: "1px solid #e9e9ef", boxShadow: "0 1px 6px rgba(0,0,0,0.05)" }}
              >
                {/* Panel header */}
                <div
                  className="d-flex align-items-center justify-content-between p-3"
                  style={{ borderBottom: "1px solid #f0f0f0" }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <p className="mb-0 text-muted" style={{ fontSize: 11, fontWeight: 600, letterSpacing: "0.8px", textTransform: "uppercase" }}>
                      Selected Case Studies
                    </p>
                    <span
                      className="rounded-pill px-2"
                      style={{ background: "#f3e8ff", color: "#7c3aed", fontSize: 11, fontWeight: 600 }}
                    >
                      {SelectedCaseStudies.length}
                    </span>
                  </div>
                  {SelectedCaseStudies.length > 0 && (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger py-0"
                      style={{ fontSize: 12 }}
                      onClick={() => setSelectedCaseStudies([])}
                    >
                      Clear All
                    </button>
                  )}
                </div>

                {/* Selected list */}
                <div style={{ maxHeight: 420, overflowY: "auto" }}>
                  {SelectedCaseStudies.length === 0 ? (
                    <div className="text-center text-muted py-5" style={{ fontSize: 13 }}>
                      <i className="fas fa-folder-open d-block mb-2" style={{ fontSize: 28, opacity: 0.3 }} />
                      No case studies selected yet.
                    </div>
                  ) : (
                    SelectedCaseStudies.map((cs, idx) => (
                      <div
                        key={cs.value}
                        className="d-flex align-items-start justify-content-between px-3 py-2"
                        style={{ borderBottom: "1px solid #f8f8f8" }}
                      >
                        <div className="d-flex align-items-start gap-2">
                          <span
                            style={{
                              width: 22, height: 22, borderRadius: 6, flexShrink: 0,
                              background: "#7c3aed", color: "#fff",
                              display: "flex", alignItems: "center", justifyContent: "center",
                              fontSize: 10, fontWeight: 700, marginTop: 1,
                            }}
                          >
                            {idx + 1}
                          </span>
                          <div>
                            <p
                              className="mb-0 fw-semibold"
                              style={{ fontSize: 13, color: "#1f2937", cursor: "pointer" }}
                              onClick={() => { setProjectId(cs.id); setmodal_fullscreen(true) }}
                            >
                              {cs.label}
                            </p>
                            <div className="d-flex gap-1 mt-1 flex-wrap">
                              {cs.location && (
                                <span style={{ fontSize: 10, background: "#fef3c7", color: "#92400e", borderRadius: 4, padding: "1px 6px" }}>
                                  {generalLocation?.find(l => l.value == cs.location)?.label || null}
                                </span>
                              )}
                              {cs.services && (
                                <span style={{ fontSize: 10, background: "#e0f2fe", color: "#0369a1", borderRadius: 4, padding: "1px 6px" }}>
                                  {cs.services}
                                </span>
                              )}
                              {Array.isArray(cs.technologies) && cs.technologies.slice(0, 2).map((t, i) => (
                                <span key={i} style={{ fontSize: 10, background: "#f0fdf4", color: "#166534", borderRadius: 4, padding: "1px 6px" }}>
                                  {t}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="align-self-center">
                          <button
                            type="button"
                            title="View case study"
                            onClick={() => {
                              setProjectId(cs.id);
                              setmodal_fullscreen(true);
                            }}
                            className="btn btn-sm btn-outline-secondary"
                          >
                            <i className="fa fa-eye"></i>
                          </button>

                          <button
                            type="button"
                            onClick={() => toggleCaseStudy(cs)}
                            className="btn btn-sm btn-outline-danger ms-2"
                          >
                            <i className="fa fa-times"></i>
                          </button>
                        </div>
                      </div>
                    ))
                  )}
                </div>

                {SelectedCaseStudies.length > 0 && (
                  <div className="px-3 py-2" style={{ borderTop: "1px solid #f0f0f0" }}>
                    <p className="mb-0 text-muted" style={{ fontSize: 11 }}>
                      💡 Click a project name to preview details.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

        </Form>
      </Container>

      {/* ── View Case Study Modal ─────────────────────────────────────────── */}
      <Modal size="xl" isOpen={modal_fullscreen} className="modal-fullscreen">
        <div className="modal-header mb-0">
          <div className="d-flex align-items-center justify-content-between w-100">
            <h5 className="modal-title mt-0">View Project Details</h5>
          </div>
          <button
            type="button"
            onClick={() => setmodal_fullscreen(false)}
            className="ms-4"
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <span aria-hidden="true" style={{ color: "#bf1e30", fontSize: "28px", lineHeight: "1px" }}>
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body hide-bottom-scrollbar ps-3 pe-0 pt-0">
          <Row className="gx-4 justify-content-between">
            <ViewCaseStudy projectId={projectId} />
          </Row>
        </div>
      </Modal>
    </div>
  )
}

export default Addportfolio